import { AnyAction, combineReducers } from 'redux';

import { baseApi } from '@Services/baseApi.service';
import authReducer, { logout } from '@Slices/auth.slice';
import alertReducer from '@Slices/globalAlert.slice';
import uploadReducer from '@Slices/upload.slice';

/** Combination of all Reducers */
const appReducer = combineReducers({
  alert: alertReducer,
  auth: authReducer,
  emailUpload: uploadReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

/**
 * @description Clears cache of RTK Query after logout
 * @param state State consisting of all reducers
 * @param action Specific action
 * @returns Combination of all Reducers
 */
const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: AnyAction
): ReturnType<typeof appReducer> => {
  let updatedState: ReturnType<typeof appReducer> | undefined = state;

  if (logout.match(action)) {
    updatedState = undefined; // Reset all states
  }

  return appReducer(updatedState, action);
};

// The RootState automatically takes the shape of the rootReducer object, therefore you don't have to update the RootState interface as and when you add more slice reducers
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
